import React from "react";
import styles from "./watchlistWrapped.module.css";
import { WrappedDailySnapshotPlaceholder } from "~components/WrappedDailySnapshot/dailySnapshotPlaceholder";
import { WrappedTopMoversPlaceholder } from "~components/WrappedTopMovers/topMoversPlaceholder";
import { WrappedPerformanceChartPlaceholder } from "~components/WrappedPerformanceChart/performanceChartPlaceholder";

export function WrappedContentPlaceholder() {
  return (
    <div className={styles.mainContent}>
      <div className={styles.snapshotAndMoversSection}>
        <div className={styles.snapshotWrapper}>
          <WrappedDailySnapshotPlaceholder />
        </div>

        <div className={styles.verticalDivider} role="separator" />

        <div className={styles.moversSection}>
          <WrappedTopMoversPlaceholder />
        </div>
      </div>

      <div className={styles.horizontalDivider} role="separator" />

      <div className={styles.chartSection}>
        <WrappedPerformanceChartPlaceholder />
      </div>
    </div>
  );
}
